module.exports = __webpack_public_path__ + "img/employee.3907180f.png";